var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.07984 12.5874C4.70362 12.5874 5.21467 13.0985 5.21467 13.7297C5.21467 14.3535 4.70362 14.8646 4.07984 14.8646C3.44855 14.8646 2.9375 14.3535 2.9375 13.7297C2.9375 13.0985 3.44855 12.5874 4.07984 12.5874ZM12.5347 12.5874C13.1585 12.5874 13.6695 13.0985 13.6695 13.7297C13.6695 14.3535 13.1585 14.8646 12.5347 14.8646C11.9034 14.8646 11.3923 14.3535 11.3923 13.7297C11.3923 13.0985 11.9034 12.5874 12.5347 12.5874Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.661914 0.141515L2.45434 0.412069C2.70986 0.457913 2.89775 0.667593 2.92029 0.923117L3.06309 2.60657C3.08563 2.84781 3.28103 3.02818 3.52153 3.02818H13.6711C14.1295 3.02818 14.4301 3.18601 14.7308 3.53171C15.0314 3.87742 15.084 4.37344 15.0163 4.82361L14.3024 9.75372C14.1671 10.7014 13.3554 11.3996 12.401 11.3996H4.20167C3.20212 11.3996 2.37543 10.633 2.29276 9.64174L1.60134 1.4492L0.466513 1.25379C0.165897 1.20119 -0.0445347 0.908086 0.00807316 0.60747C0.060681 0.299338 0.353782 0.0964222 0.661914 0.141515ZM11.1985 5.80813H9.11675C8.8011 5.80813 8.55309 6.05614 8.55309 6.37179C8.55309 6.67992 8.8011 6.93544 9.11675 6.93544H11.1985C11.5142 6.93544 11.7622 6.67992 11.7622 6.37179C11.7622 6.05614 11.5142 5.80813 11.1985 5.80813Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.43e14d8849d731b27bcfb934878229b5.svg";
export { ForwardRef as ReactComponent };